import en from './en.json'
import sv from './sv.json'

export const translations = {
  en,
  sv
}
